import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loyaltic-rewards-deliverable',
  templateUrl: './rewards-deliverable.component.html',
  styleUrls: ['./rewards-deliverable.component.scss']
})
export class RewardsDeliverableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
